import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './WorldIndices.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import OtherMarketOption from "../../OtherMarketOption/OtherMarketOption";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../../Activity_Track/CallTrackApi";

function WorldIndices() {
    const [data, setData] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        const getUrl = BaseURL + "OtherMarkets";


        fetch(`${getUrl}/WIN/20`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                //console.log(getData, "getData")
                setloadingshow(false);
            })
            .catch((error) => {
            });


    }, []);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    CallTrackApi("World Indices",window.location.href);

    
    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>World Indices</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='world-loser-sc'>
                            <div className='world-header'>
                                <h2><span>World Indices</span></h2>
                            </div>
                            <OtherMarketOption optionOtherMarket="World Indices" />
                            <hr className="worldhr"></hr>
                            <div className='world-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>

                                            <th className='text-left' >Indices</th>
                                            <th className='text-left' >Country</th>
                                            <th className='text-left' >Date</th>
                                            <th className='text-right'>Index</th>
                                            <th className='text-right'>Net Change</th>
                                            <th className='text-right'>Change %</th>


                                        </tr>

                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ IndiceName, Country, date, close, Chg, PChg }) => (
                                                <tr>
                                                    <td className="text-left"> {IndiceName}</td>
                                                    <td className="text-left"> {Country}</td>
                                                    <td className="text-left"> {(date != null) ? date.split('T')[0] : 0}</td>
                                                    <td className="text-right"> {(close != null) ? close.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(Chg != null) ? Chg.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(PChg != null) ? PChg.toFixed(2) : 0}</td>





                                                </tr>
                                            ))}
                                    </tbody>
                                </table>

                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }


                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default WorldIndices;